import React from "react";
// import ReactDOM from 'react-dom';
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import networkService from "./api/networkService.js";
import "./utils/fontawersome";

import "./assets/css/bootstrap.css";
import "./assets/sass/bootstrap-rtl.min.scss";
import "./assets/css/socicons.css";
import "./assets/css/hover.css";
import "./assets/css/animate.css";
// import './assets/css/style-green.css';
import "./assets/css/style-blue.css";
import "./assets/css/index.css";
import "./assets/sass/App.scss";

// import App from './App';
import reportWebVitals from "./reportWebVitals";

import configureStore, { history } from "./redux/store/configureStore";
import BaseLayout from "./layouts/BaseLayout";

const state = window.__initialState__ || undefined;
const store = configureStore(
  state,
  window.__REDUX_DEVTOOLS_EXTENSION && window.__REDUX_DEVTOOLS_EXTENSION()
);

networkService.setupInterceptors(store, history);

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BaseLayout history={history} />
  </Provider>
);

// ReactDOM.render(
//   <React.StrictMode>
//     <Provider store={ store }>
//       <BaseLayout history={ history } />
//     </Provider>
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorker.unregister();
